<script>
import Content from '@/services/Content'
import validationMessages from '@/components/validations'
import { required } from "vuelidate/lib/validators";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

export default {
    components: {
        validationMessages,
        flatPickr,
        vueDropzone: vue2Dropzone,
    },
    props: {
        videoData: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            csrf_token: localStorage.getItem('csrf_token'),
            showModal: false,
            tryingToSubmit: false,
            submitted: false,
            title: "",
            description: "",
            thumbnail: null,
            tags: [],
            publish: null,
            date: '',
            time: '',
            isPremium: false,

            tagInput: '',
            thumbnailPreviewUrl: null,
            thumbnailDeleted: false,
            isDragOver: false,
            dateconfig: {
                enableTime: false,
                dateFormat: "Y-m-d",
            },
            timeconfig: {
                enableTime: true,
                noCalendar: true,
                time_24hr: true,
                minuteIncrement: 1,
                dateFormat: "H:i",
                allowInput: true
            },
            dropzoneOptions_thumbnail: {
                url: '/',
                autoProcessQueue: false,
                addRemoveLinks: true,
                thumbnailWidth: 800,
                thumbnailHeight: null,
                thumbnailMethod: 'contain',
                maxFilesize: 4,
                acceptedFiles: 'image/jpeg,image/png,image/bmp,image/webp',
                maxFiles: 1,
            },
        };
    },
    validations: {
        title: { required },
        description: {},
        tags: {},
        thumbnail: {},
    },
    watch: {
        showModal(val) {
            if (val) this.populateFromProps();
        }
    },
    methods: {
        refreshData() {
            this.$emit('onRefresh')
        },
        populateFromProps() {
            const v = this.videoData;
            console.log(v,'videodata');
            this.title = v.title || '';
            this.description = v.desc || v.description || '';
            if (Array.isArray(v.tags)) {
                this.tags = [...v.tags];
            } else if (typeof v.tags === 'string' && v.tags.length) {
                this.tags = v.tags.split(',').map(t => t.trim()).filter(Boolean);
            } else {
                this.tags = [];
            }
            this.isPremium = !!(v.premium || v.is_premium);
            this.thumbnail = null;

            const publishedAt = v.published || v.publish;
            if (publishedAt) {
                const parts = String(publishedAt).split(' ');
                this.date = parts[0] || '';
                this.time = parts[1] || '';
                this.publish = publishedAt;
            }

            this.thumbnailPreviewUrl = v.image || v.thumbnail_url || null;
        },
        addTag() {
            const tag = this.tagInput.trim().replace(/,+$/, '');
            if (tag && !this.tags.includes(tag)) {
                this.tags.push(tag);
            }
            this.tagInput = '';
        },
        removeTag(index) {
            this.tags.splice(index, 1);
        },
        editVideo() {
            this.tryingToSubmit = true;
            this.submitted = true;
            this.$v.$touch();

            if (this.$v.$invalid) {
                this.tryingToSubmit = false;
                return;
            }

            const formData = new FormData();
            formData.append('source_id', this.videoData.id);
            formData.append("title", this.title);
            formData.append("description", this.description);
            if (this.thumbnail) formData.append("image_file", this.thumbnail);
            this.tags.forEach((tag) => formData.append("tags[]", tag));
            if (this.date) {
                formData.append("published", this.time ? `${this.date} ${this.time}` : this.date);
            }
            formData.append("premium", this.isPremium ? 1 : 0);
            formData.append("csrf_token", this.csrf_token);
            formData.append("_method",'PATCH')

            Content.editVideo(this.videoData.id,formData)
                .then(() => {
                    this.successmsg("Video Updated!");
                    this.closeModal();
                    this.refreshData();
                })
                .catch((error) => {
                    const errorMsg = error.response?.data?.error || "Failed to update video";
                    this.failedmsg(errorMsg);
                })
                .finally(() => {
                    this.tryingToSubmit = false;
                });
        },
        closeModal() {
            this.showModal = false;
        },
        openDatePicker() {
            this.$refs.datePicker.$el.click();
        },
        openTimePicker() {
            this.$refs.timePicker.$el.click();
        },
        updatePublished() {
            if (this.date && this.time) {
                this.publish = `${this.date} ${this.time}`;
            } else if (this.date) {
                this.publish = this.date;
            } else {
                this.publish = null;
            }
        },
        resetProps() {
            this.submitted = false;
            this.title = '';
            this.description = '';
            this.tags = [];
            this.tagInput = '';
            this.thumbnail = null;
            this.thumbnailPreviewUrl = null;
            this.thumbnailDeleted = false;
            this.isDragOver = false;
            this.publish = null;
            this.date = '';
            this.time = '';
            this.isPremium = false;
            this.$nextTick(() => {
                if (this.$refs.myVueDropzone_thumbnail_url) {
                    this.$refs.myVueDropzone_thumbnail_url.removeAllFiles();
                }
            });
        },
        selectFileThumbnailUrl(files) {
            if (files.length > 1) {
                this.failedmsg('You can only have one thumbnail');
                files.slice(1).forEach((f) => this.$refs.myVueDropzone_thumbnail_url.removeFile(f));
            }
            const thumbnailFile = files[0] || null;
            this.thumbnail = thumbnailFile;
            this.thumbnailDeleted = false;
            if (thumbnailFile) {
                this.thumbnailPreviewUrl = URL.createObjectURL(thumbnailFile);
            }
        },
        clearThumbnail() {
            if (this.thumbnailPreviewUrl && this.thumbnailPreviewUrl.startsWith('blob:')) {
                URL.revokeObjectURL(this.thumbnailPreviewUrl);
            }
            this.thumbnailPreviewUrl = null;
            this.thumbnail = null;
            this.thumbnailDeleted = true;
            this.$refs.myVueDropzone_thumbnail_url.removeAllFiles();
        },
    }
};
</script>

<template>
    <b-modal id="edit_video" size="lg" v-model="showModal" @hidden="resetProps" title-class="font-18">
        <template v-slot:modal-header>
            <div class="w-100">
                <h5 class="modal-title mb-0">Edit Video</h5>
                <p class="text-muted mb-0 mt-2">Update the details of this video</p>
            </div>
            <button type="button" class="btn-close" @click="closeModal" aria-label="Close"></button>
        </template>
        <form @submit.prevent="editVideo">
            <div class="card mb-3">
                <div class="card-body py-2">
                    <h4 class="card-title mb-1">Basic Information</h4>
                    <p class="text-muted mb-3">Essential details about your video</p>
                    <div>
                        <div class="mb-2">
                            <label class="mb-1">Title *</label>
                            <b-form-input v-model="title" :state="submitted && $v.title.$error ? false : null"></b-form-input>
                        </div>
                        <validationMessages v-if="submitted" :fieldName="'Title'" :validationName="$v.title">
                        </validationMessages>
                    </div>
                    <div>
                        <div class="mb-2">
                            <label class="mb-1">Description</label>
                            <b-form-input v-model="description"></b-form-input>
                        </div>
                    </div>
                    <div>
                        <div class="mb-2">
                            <label class="mb-1">Tags</label>
                            <div class="tag-input-container">
                                <span
                                    v-for="(tag, index) in tags"
                                    :key="tag"
                                    class="tag-pill"
                                >
                                    {{ tag }}
                                    <button type="button" class="tag-remove" @click="removeTag(index)">&times;</button>
                                </span>
                                <input
                                    v-model="tagInput"
                                    class="tag-text-input"
                                    placeholder="Type and press Enter or comma..."
                                    @keydown.enter.prevent="addTag"
                                    @keydown.188.prevent="addTag"
                                    @blur="tagInput.trim() && addTag()"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2 mb-2">
                        <div class="col-md-6">
                            <label class="mb-1">
                                <i class="uil uil-calendar-alt me-1"></i>Publish Date
                            </label>
                            <div class="position-relative">
                                <flat-pickr ref="datePicker" v-model="date" :config="dateconfig"
                                    class="form-control pe-4" name="date" @on-change="updatePublished" />
                                <i class="uil uil-calendar-alt position-absolute top-50 end-0 translate-middle-y me-2 text-muted"
                                    style="cursor: pointer; pointer-events: all;" @click="openDatePicker"></i>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label class="mb-1">
                                <i class="uil uil-clock me-1"></i>Publish Time
                            </label>
                            <div class="position-relative">
                                <flat-pickr ref="timePicker" v-model="time" :config="timeconfig"
                                    class="form-control pe-4" name="time" @on-change="updatePublished" />
                                <i class="uil uil-clock position-absolute top-50 end-0 translate-middle-y me-2 text-muted"
                                    style="cursor: pointer; pointer-events: all;" @click="openTimePicker"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card mb-3">
                <div class="card-body py-2">
                    <h4 class="card-title mb-1">
                        <i class="uil uil-image me-2"></i>Thumbnail
                    </h4>
                    <p class="text-muted mb-3">Replace the thumbnail (optional)</p>
                    <b-form-group label-for="thumbnail" class="mb-0">
                        <div class="video-upload">
                            <div v-if="thumbnailPreviewUrl" class="thumbnail-preview-container">
                                <img :src="thumbnailPreviewUrl" class="thumbnail-preview" alt="thumbnail" />
                                <div class="video-preview-meta">
                                    <span v-if="thumbnail" class="video-name">{{ thumbnail.name }}</span>
                                    <span v-else class="video-name text-muted">Current thumbnail</span>
                                    <a href="#" class="remove-link" @click.prevent="clearThumbnail">
                                        <i class="uil uil-trash-alt me-1"></i>Remove
                                    </a>
                                </div>
                            </div>
                            <vue-dropzone v-show="!thumbnailPreviewUrl" id="thumbnailEditDropzone"
                                ref="myVueDropzone_thumbnail_url" :use-custom-slot="true"
                                :options="dropzoneOptions_thumbnail" @vdropzone-files-added="selectFileThumbnailUrl"
                                no-progress-bar>
                                <div class="video-upload__placeholder">
                                    <i class="uil uil-import"></i>
                                    <span>Drag and drop an image, or click to browse</span>
                                    <small>PNG, JPG up to 4MB</small>
                                </div>
                            </vue-dropzone>
                        </div>
                    </b-form-group>
                </div>
            </div>

            <div class="card mb-3">
                <div class="card-body py-2">
                    <div class="d-flex align-items-center justify-content-between">
                        <div>
                            <h4 class="card-title mb-0">Premium Content</h4>
                            <p class="text-muted mb-0 mt-1" style="font-size:13px;">Restrict this video to premium subscribers only</p>
                        </div>
                        <div class="form-check form-switch form-switch-lg mb-0">
                            <input v-model="isPremium" type="checkbox" class="form-check-input" id="isPremiumEditSwitch" />
                        </div>
                    </div>
                </div>
            </div>

            <input type="hidden" name="csrf_token" v-model="csrf_token">
        </form>
        <template v-slot:modal-footer>
            <b-button variant="light" @click="closeModal">Close</b-button>
            <b-button variant="primary" @click="editVideo" :disabled="tryingToSubmit">
                <b-spinner v-show="tryingToSubmit" small></b-spinner>
                Save Changes
            </b-button>
        </template>
    </b-modal>
</template>

<style scoped>
.video-upload {
    border: 2px dashed #d3d8e6;
    border-radius: 16px;
    background: #f7f8fb;
    padding: 16px;
    transition: border-color 0.2s ease, background 0.2s ease;
    overflow: hidden;
}

.video-upload.has-error {
    border-color: #f97373;
    background: #fff5f5;
}

.video-upload__placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    color: #5f6b7d;
    font-size: 14px;
    padding: 24px 0;
}

.video-upload__placeholder i {
    font-size: 32px;
    color: #151a2d;
}

.video-upload__placeholder small {
    color: #a0aec0;
}

/* --- thumbnail preview --- */
.thumbnail-preview-container {
    width: 100%;
}

.thumbnail-preview {
    width: 100%;
    max-height: 220px;
    border-radius: 8px;
    display: block;
    object-fit: cover;
}

.video-preview-meta {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 2px 0;
}

.video-name {
    font-size: 13px;
    color: #5f6b7d;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 80%;
}

.remove-link {
    font-size: 12px;
    color: #f97373;
    text-decoration: none;
    white-space: nowrap;
}

.remove-link:hover {
    color: #e05555;
}

/* --- tag input --- */
.tag-input-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    min-height: 42px;
    padding: 6px 10px;
    border: 1px solid #ced4da;
    border-radius: 4px;
    background: #fff;
    cursor: text;
}

.tag-pill {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 8px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.6;
    white-space: nowrap;
    background: #34c38f;
    color: #fff;
}

.tag-remove {
    background: none;
    border: none;
    padding: 0;
    line-height: 1;
    font-size: 14px;
    cursor: pointer;
    opacity: 0.6;
    color: inherit;
}

.tag-remove:hover {
    opacity: 1;
}

.tag-text-input {
    border: none;
    outline: none;
    font-size: 14px;
    flex: 1;
    min-width: 140px;
    background: transparent;
    color: #495057;
}

/* --- dropzone preview overrides --- */
.video-upload /deep/ .vue-dropzone {
    border: none;
    background: transparent;
    padding: 0;
    min-height: auto;
}

.video-upload /deep/ .dz-preview {
    display: block;
    width: 100%;
    margin: 0;
    min-height: auto;
}

.video-upload /deep/ .dz-image {
    width: 100%;
    height: 220px;
    border-radius: 8px;
    overflow: hidden;
}

.video-upload /deep/ .dz-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.video-upload /deep/ .dz-details {
    position: static;
    padding: 8px 4px 0;
    opacity: 1;
    background: transparent;
}

.video-upload /deep/ .dz-filename span,
.video-upload /deep/ .dz-size span {
    background: transparent;
    border: none;
    font-size: 13px;
    color: #5f6b7d;
}

.video-upload /deep/ .dz-remove {
    display: block;
    margin-top: 6px;
    font-size: 12px;
    color: #f97373;
    text-align: center;
    text-decoration: none;
}

.video-upload /deep/ .dz-success-mark,
.video-upload /deep/ .dz-error-mark,
.video-upload /deep/ .dz-progress {
    display: none !important;
}
</style>
